import React from 'react'
import { SVGIconProps } from '../types'
const SvgTitle = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M5 4v3h5.5v12h3V7H19V4z" />
  </svg>
)
export default SvgTitle
